import { useEffect, useRef } from 'react';
import { create } from 'zustand';
let nextEventId = 0;
const useConnectorDisconnectStore = create((set) => ({
    lastEvent: null,
    emitConnectorDisconnect: (args) => set({ lastEvent: { ...args, id: ++nextEventId } }),
}));
/**
 * Subscribes to connector disconnect events. The callback fires once per disconnect,
 * regardless of how many times sources or other state changes in the component.
 * Safe to call with reconnect/re-add flows — a stale disconnect event will not
 * retrigger after the component re-renders.
 */
export const useOnConnectorDisconnect = (callback) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    useEffect(() => {
        return useConnectorDisconnectStore.subscribe((state, prevState) => {
            if (state.lastEvent === prevState.lastEvent || !state.lastEvent)
                return;
            callbackRef.current(state.lastEvent);
        });
    }, []);
};
export const emitConnectorDisconnect = (args) => useConnectorDisconnectStore.getState().emitConnectorDisconnect(args);
//# sourceMappingURL=useConnectorDisconnectEvents.js.map